export enum AccountingExportFileType {
    pdf = 0,
    excel = 1,
    preview = 2
}
